import moment from 'moment';

const approval = {
  title: 'Approval Status',
  dataIndex: 'approvalStatus',
  key: 'approvalStatus',
  render: (value) => {
    return value == 'PENDING' ? 'Doesn\'t send for approval' : value;
  }
};

const viewColomn = (isApproval) => {
  const data = [
    {
      title: 'Added By',
      dataIndex: '',
      key: '',
      render: (text) => {
        if (text && text.addedBy) {
          return (text && text.addedBy.firstName) ? [text.addedBy.firstName, text.addedBy.lastName].join(' ') : '';
        } else if (text && text.addedByVendor) {
          return (text && text.addedByVendor.firstName) ? [text.addedByVendor.firstName, text.addedByVendor.lastName].join(' ') : '';
        } else {
          return;
        }
      }
    },
    {
      title: 'Updated By',
      dataIndex: 'updatedBy',
      key: 'updatedBy',
      render: (text) => {
        return (text && text.firstName) ? [text.firstName, text.lastName].join(' ') : '';
      }
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text) => {
        return moment(text).format('lll');
      }
    },
    {
      title: 'Updated At',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (text) => {
        return moment(text).format('lll');
      }
    },
  ];
  if (isApproval) {
    data.push(approval);
  }

  return data;
};

const addForm = () => {
  return [
    {
      title: 'Send For CEO Approval',
      dataIndex: 'approvalStatus',
      key: 'approvalStatus',
      hideFromApproval: true,
      type: 'select',
      children: [{ value: 'Yes', name: 'WAITING_APPROVAL' }, { value: 'No', name: 'PENDING' }],
      isRequired: false,
      formClassName: 'col-4 pb-2',
    },
    {
      title: 'Approval Need Form',
      dataIndex: 'approvalFrom',
      key: 'approvalFrom',
      hideFromApproval: true,
      type: 'select',
      isCombo: true,
      isRequired: false,
      formClassName: 'col-4 pb-2',
    },
    {
      title: 'Approval Status',
      dataIndex: 'approvalStatus',
      hideFromOther: true,
      key: 'approvalStatus',
      type: 'select',
      children: ['PENDING', 'WAITING_APPROVAL', 'APPROVED', 'REJECTED', 'IN_PROGRES'].map(ele => ({ value: ele, name: ele })),
      isRequired: false,
      formClassName: 'col-4 pb-2',
    },
  ];
};

const technoLogies = () => {
  const techStacks = ['ReactJs', 'AngularJS', 'Angular2+', 'Nodejs', 'NextJS', 'NestJS', 'VueJS', 'JAVA', '.net', 'GitHub',
    'GitLab', 'AWS', 'Azure', 'ReactNative', 'flutter', 'Android', 'IOS', 'SpringBoot', 'C#', 'UI/UX', 'CSS', 'SCSS', 'Typescript',
    'JS', 'html', 'html5', 'PHP', 'Laravel'];
  return techStacks.map(ele => ({ name: ele, value: ele }));
};

export { viewColomn, addForm, technoLogies };